import Vue from 'vue'
import globalConfig from 'init/global.config'

import withRender from './header.html'
import './header.scss'

export default withRender(Vue.extend({
  data() {
    return { globalConfig }
  },
  props: {
    description: String,
    heading: String,
    withBorder: {
      type: Boolean,
      default: true
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/objects/header/header.ts